import { AnimationDirection } from "@/hooks/use-user-switch-animation-init";
import { cn } from "@/lib/utils";
import { FC, PropsWithChildren, useEffect, useState } from "react";

interface AnimatedContentWrapperProps extends PropsWithChildren {
  isAnimating: boolean;
  direction: AnimationDirection;
  onAnimationEnd: () => void;
}

const AnimatedContentWrapper: FC<AnimatedContentWrapperProps> = ({
  children,
  isAnimating,
  direction,
  onAnimationEnd,
}) => {
  const [transform, setTransform] = useState("translateX(0)");

  useEffect(() => {
    if (isAnimating && direction) {
      const translateX = direction === "left" ? "-100%" : "100%";
      setTransform(`translateX(${translateX})`);

      const timer = setTimeout(() => {
        setTransform("translateX(0)");
        setTimeout(onAnimationEnd, 300);
      }, 300);

      return () => clearTimeout(timer);
    }
  }, [isAnimating, direction, onAnimationEnd]);

  return (
    <div
      className={cn(
        "transition-transform duration-300 ease-in-out",
        isAnimating && "pointer-events-none",
      )}
      style={{ transform }}
    >
      {children}
    </div>
  );
};

export default AnimatedContentWrapper;
